module.exports = __webpack_public_path__ + "img/feature11.ff894f6.png";